class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);  
    
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
     this.hideAllFilters(); 
  }


   hideAllFilters() {
    const disclosure = document.querySelector('details.js-filter');
    var listength = false
      document.querySelectorAll('details.js-filter').forEach((element) => { 
     if (element.dataset.title !== 'Availability') {  
      var elementlength = element.querySelectorAll("ul.facets-layout-list li").length;    
      if (elementlength > 1) { 
       listength = true;
        }   }
       }); 
          if (listength == true) {  
          document.querySelector('ul#product-grid').classList.remove('grid--5-col-desktop');
          document.querySelector('ul#product-grid').classList.add('grid--4-col-desktop');
          document.querySelector('aside.facets-wrapper').classList.remove('hidden'); 
        } else { 
          document.querySelector('ul#product-grid').classList.add('grid--5-col-desktop');
          document.querySelector('ul#product-grid').classList.remove('grid--4-col-desktop');
          document.querySelector('aside.facets-wrapper').classList.add('hidden'); 
        }
    }

  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
 
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
     rangeInputFilter();rangeMobileInputFilter();
    var itg_itemcount = $('.itg_itemcount').length;
    var itg_itemcount = 18 - itg_itemcount;
    $(".itg_gird #product-grid li.grid__item").slice(0, itg_itemcount).show();
       
  }

    // initAvailabilityFilters() {
    //   // Hide the Availability disclosure
    //   const disclosure = document.querySelector('[data-title="Availability"]');
    //   disclosure.style.display = 'none';

    //   this.inStockFilter = document.querySelector('[for="Filter-filter.v.availability-1"]');
    //   const urlParams = new URLSearchParams(window.location.search);
    //   let hasFilters = false;
    //   let hasFilterAvailability = false;
    //   urlParams.forEach((value, key) => {
    //     if (key.includes('filter.v')) {
    //       hasFilters = true;
    //     }
    //     if (key === 'filter.v.availability') {
    //       hasFilterAvailability = true;
    //     }
    //   });
    //   if (hasFilters && !hasFilterAvailability) {
    //     console.log(this.inStockFilter);
    //     this.inStockFilter.click(); // Apply only the "in stock" option
    //   }
    // }
  
  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    
    const endlessCollection = new Ajaxinate({
	container: '#product-grid',
	pagination: '#productLoopPagination',
	});
    
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    let hasFilterAvailability = false;
      formData.forEach((value, key) => {
        if (key === 'filter.v.availability') {
          hasFilterAvailability = true;
        }
      });
    
      if (hasFilterAvailability) {
      return new URLSearchParams(formData).toString(); 
      } else {
      const newsearchParams = 'filter.v.availability=1&'+new URLSearchParams(formData).toString();
        return newsearchParams;
      }
    
    // return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            // forms.push(this.createSearchParams(form));
            const SearchParamElements = this.createSearchParams(form);
            if (window.location.pathname == '/search') { 
            var searcQuery = document.querySelector('.header__search .search__input[name="q"]').value;
            var searcparaQuery = 'q='+searcQuery+'&options%5Bprefix%5D=last&filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte=';
            if (SearchParamElements == searcparaQuery){
              forms.push('q='+searcQuery+'&options%5Bprefix%5D=last');
            }else {
            forms.push(this.createSearchParams(form));
            } 
            }else {
            if (SearchParamElements == 'filter.v.availability=1&filter.v.price.gte=&filter.v.price.lte='){
              forms.push('');
            }else {
            forms.push(this.createSearchParams(form));
            }
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    // FacetFiltersForm.renderPage(url);
    
        var listength = false; var elementlength = 0;
        const form = document.querySelector('facet-filters-form') || document.querySelector('facet-filters-form');
        var searcQuery = document.querySelector('.header__search .search__input[name="q"]').value;
        form.querySelectorAll('facet-remove[data-title]').forEach((element) => {  
        elementlength += 1;  
        });
        
        if (window.location.pathname == '/search'){
        if (elementlength <= 2) {  
        FacetFiltersForm.renderPage('q='+searcQuery+'&options%5Bprefix%5D=last');
        } 
        else { 
        FacetFiltersForm.renderPage(url);
        }
        } else { 
        if (url == 'filter.v.availability=1'){
        FacetFiltersForm.renderPage('');
        }
        else { 
        FacetFiltersForm.renderPage(url);
        } 
        }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

function rangeInputFilter() {
const rangeInput = document.querySelectorAll(".range-input-bar input"),
  // rangeMobileInput = document.querySelectorAll(".range-mobileinput-bar input"),
  priceInput = document.querySelectorAll(".price-input input"),
  range = document.querySelector(".range--slider_bar .range-progress-bar"),
  priceInputMin = document.querySelector("price-range.facets__price input.field__input[data-min]"),
  priceInputMax = document.querySelector("price-range.facets__price input.field__input[data-max]"),
  priceTextminimum = document.querySelector(".price-range-title-bar .price--title-minimum"),
  priceTextmaximum = document.querySelector(".price-range-title-bar .price--title-maximum");
 let priceGap = 1;

 rangeInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minVal = parseFloat(rangeInput[0].value),
      maxVal = parseFloat(rangeInput[1].value);

    if (maxVal - minVal < priceGap) {
      if (e.target.className === "range-min") {
        rangeInput[0].value = maxVal - priceGap;
        priceInputMin.value == rangeInput[0].value;
        priceTextminimum.textContent = '$'+rangeInput[0].value;
      } else {
        rangeInput[1].value = minVal + priceGap;
        priceInputMax.value = rangeInput[1].value; 
        priceTextmaximum.textContent = '$'+rangeInput[1].value;
      }
    } else {
      priceInput[0].value = minVal;
      priceInput[1].value = maxVal;
      priceInputMin.value = minVal;
      priceInputMax.value = maxVal; 
      priceTextminimum.textContent = '$'+minVal;
      priceTextmaximum.textContent = '$'+maxVal;
      range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
      range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
    }
  });
});}
 rangeInputFilter();

customElements.define('facet-remove', FacetRemove);


function rangeMobileInputFilter() {
const rangeInput = document.querySelectorAll(".range-mobileinput-bar input"), 
  priceInput = document.querySelectorAll(".mobile-price-input input"),
  range = document.querySelector(".mobilerange--slider_bar .range-progress-bar"),
  priceInputMin = document.querySelector("price-range.mobilefacets__price input.field__input[data-min]"),
  priceInputMax = document.querySelector("price-range.mobilefacets__price input.field__input[data-max]"),
  priceTextminimum = document.querySelector(".mobileprice-range-title-bar .price--title-minimum"),
  priceTextmaximum = document.querySelector(".mobileprice-range-title-bar .price--title-maximum");
 let priceGap = 1;

 rangeInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minVal = parseFloat(rangeInput[0].value),
      maxVal = parseFloat(rangeInput[1].value);
// console.log(maxVal);
    if (maxVal - minVal < priceGap) {
      if (e.target.className === "range-min") {
        rangeInput[0].value = maxVal - priceGap;
        priceInputMin.value == rangeInput[0].value;
        priceTextminimum.textContent = '$'+rangeInput[0].value;
      } else {
        rangeInput[1].value = minVal + priceGap;
        priceInputMax.value = rangeInput[1].value; 
        priceTextmaximum.textContent = '$'+rangeInput[1].value;
      }
    } else {
      priceInput[0].value = minVal;
      priceInput[1].value = maxVal;
      priceInputMin.value = minVal;
      priceInputMax.value = maxVal; 
      priceTextminimum.textContent = '$'+minVal;
      priceTextmaximum.textContent = '$'+maxVal;
      range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
      range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
    }
  });
});}
 rangeMobileInputFilter();


  // const listClick = document.querySelectorAll('.collection-sort-list .sort_options'); 
  // listClick.forEach((a) => {
  //  a.addEventListener("click", (event) => {
  //   event.preventDefault();
  //    console.log(this.dataset.value);
  //  // const dataValue = this.dataset.value;
  //   alert(this.getAttribute('data-value'));
  // });

    
  // });